(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Drawers ---------- */
  function toggle(el, open) {
    if (!el) return;
    el.classList.toggle('is-open', open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('no-scroll', open);
  }
  function openCart() { toggle($('#CartDrawer'), true); }
  function closeCart() { toggle($('#CartDrawer'), false); }

  function refreshCart(open) {
    return fetch(window.theme.routes.cart + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
        var fresh = $('#CartDrawerInner', doc);
        var cur = $('#CartDrawerInner');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          cur.setAttribute('data-count', fresh.getAttribute('data-count'));
          $$('[data-cart-count]').forEach(function (n) { n.textContent = fresh.getAttribute('data-count'); });
        }
        if (open) openCart();
      });
  }

  function cartRequest(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-cart]')) { e.preventDefault(); refreshCart(true); return; }
    if (t.closest('[data-close-cart]')) { closeCart(); return; }
    if (t.closest('[data-open-menu]')) { toggle($('#MobileMenu'), true); return; }
    if (t.closest('[data-close-menu]')) { toggle($('#MobileMenu'), false); return; }

    var q = t.closest('[data-qty]');
    if (q) {
      cartRequest('/cart/change.js', { line: parseInt(q.dataset.line, 10), quantity: parseInt(q.dataset.quantity, 10) })
        .then(function () { return refreshCart(false); });
      return;
    }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('[data-qty-input]', step.closest('form'));
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
      return;
    }

    var thumb = t.closest('[data-thumb]');
    if (thumb) { showSlide(parseInt(thumb.dataset.thumb, 10)); return; }

    var dir = t.closest('[data-dir-btn]');
    if (dir) {
      $$('[data-dir-btn]').forEach(function (b) { b.classList.remove('is-active'); });
      dir.classList.add('is-active');
      $('[data-dir-name]').textContent = dir.dataset.name;
      $('[data-dir-theme]').textContent = dir.dataset.theme;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); toggle($('#MobileMenu'), false); }
  });

  /* ---------- Ajax add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action$="/cart/add"]')) return;
    e.preventDefault();
    var btn = $('[type=submit]', form);
    var label = btn && btn.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) { alert(res.description); return; }
        return refreshCart(true);
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---------- Product page: variants + gallery ---------- */
  function money(cents) {
    var f = window.theme.moneyFormat || '{{amount}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = m ? m[1] : 'amount';
    var v = cents / 100, s;
    if (type === 'amount_no_decimals') s = Math.round(v).toLocaleString('en-IN');
    else if (type === 'amount') s = v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    else s = v.toFixed(2);
    return f.replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  function showSlide(i) {
    $$('[data-slide]').forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    $$('[data-thumb]').forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
  }

  var root = $('[data-product]');
  if (root) {
    var product = JSON.parse($('[data-product-json]', root).textContent);
    var form = $('[data-product-form]', root);
    form.addEventListener('change', function (e) {
      if (!e.target.matches('.pill input')) return;
      var chosen = $$('[data-option]', form).map(function (fs) { return $('input:checked', fs).value; });
      var variant = product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      var btn = $('[data-add-btn]', form);
      if (!variant) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      $('[data-variant-id]', form).value = variant.id;
      $('[data-price]', root).textContent = money(variant.price);
      var cmp = $('[data-compare]', root), save = $('[data-save]', root);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      cmp.hidden = save.hidden = !onSale;
      if (onSale) {
        cmp.textContent = money(variant.compare_at_price);
        save.textContent = 'SAVE ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      }
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (variant.featured_media) {
        var slides = $$('[data-slide]');
        slides.forEach(function (s, n) { if (String(s.dataset.mediaId) === String(variant.featured_media.id)) showSlide(n); });
      }
      if (window.history && history.replaceState) history.replaceState({}, '', '?variant=' + variant.id);
    });
  }
})();
